import { Component, Host, Prop, h } from "@stencil/core";

@Component({
    tag: "ux-notification-bell",
    styleUrl: "notification-bell.scss",
    shadow: false,
})
export class NotificationBell {
    private baseClass: string = "ux-notification-bell";

    /** Counter to display current notification number */
    @Prop() counter: number = 0;

    render() {
        return (
            <Host class={this.baseClass}>
                <div class="ux-notification-bell__content">
                    <ux-icon
                        class="ux-notification-bell__icon"
                        name="bell"
                    ></ux-icon>
                    {this.counter > 0 && (
                        <div class="ux-notification-bell__badge">
                            <div class="ux-badge">
                                {this.counter > 99 ? "99+" : this.counter}
                            </div>
                        </div>
                    )}
                </div>
            </Host>
        );
    }
}
